import { Invoice } from '../components/invoice';
import { InvoiceStorage } from '../components/invoiceStorage';
import { InvoiceTickets } from '../components/invoiceTickets';
import { MENU_ADMIN, MENU_CUSTOMER } from './constants';

const DICCIONARIO_COMPONENTS_BY_PATH = {
  'invoice-tickets': <InvoiceTickets />,
  'invoice-storage': <InvoiceStorage />,
  'invoice-list': <Invoice />,
  'invoice-management': null,
  'invoice/:id?': null
};

const normalizeMenuProfile = ({ isAdmin = false }) => {
  const menuPaths = isAdmin ? MENU_ADMIN : MENU_CUSTOMER;

  const menuData = menuPaths.map((menuItem) => {
    // Define the base object
    const baseMenu = {
      key: menuItem.path,
      icon: null,
      label: menuItem.description
    };

    // Conditionally add `children` only if `item` exists
    if (menuItem.item) {
      baseMenu.children = menuItem.item.map((subItem) => ({
        key: subItem.path,
        icon: null,
        label: subItem.description
      }));
    }

    return baseMenu;
  });

  const paths = normalizePaths(menuPaths);
  return { menuData, paths };
};

const normalizePaths = (menu) => {
  const paths = [];

  menu.forEach((menuItem) => {
    // Check if the menuItem has an `item` array and it's not empty
    if (menuItem.item && menuItem.item.length > 0) {
      menuItem.item.forEach((subMenuItem) => {
        if (subMenuItem.path) {
          paths.push({
            path: `${subMenuItem.path}`,
            element: DICCIONARIO_COMPONENTS_BY_PATH[subMenuItem.path] // Get the component from the dictionary
          });
        }
      });
    } else if (menuItem.path) {
      // Handle menuItem without sub-items
      paths.push({
        path: `${menuItem.path}`,
        element: DICCIONARIO_COMPONENTS_BY_PATH[menuItem.path]
      });
    }
  });

  return paths;
};

export { normalizeMenuProfile, DICCIONARIO_COMPONENTS_BY_PATH };
